import { getCurrencies } from '@vue/services/api/currency.api'

const state = {
  currencies: []
}

const mutationTypes = {
  SET_CURRENCIES: 'SET_CURRENCIES'
};

const actions = {
  async getCurrencies({ commit }) {
    const currencyData = await getCurrencies();
    commit(mutationTypes.SET_CURRENCIES, currencyData.data)
  }
}

const mutations = {
  [mutationTypes.SET_CURRENCIES](state, currencies) {
    state.currencies = currencies
  }
}

const currency = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default currency
